<template>
  <div class="card border-blue-200 bg-gradient-to-br from-blue-50 to-sky-50">
    <div class="p-6 border-b border-blue-200">
      <h3 class="text-xl font-bold flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-blue-600">
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
          <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
        </svg>
        健康关系养成指南
      </h3>
    </div>
    <div class="p-6 space-y-4">
      <div class="grid md:grid-cols-2 gap-4">
        <!-- 建立信任的关键 -->
        <div class="space-y-3">
          <h4 class="font-semibold flex items-center gap-2 text-blue-700">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            建立信任的关键
          </h4>
          <ul class="text-sm text-gray-600 space-y-2 ml-6">
            <li>• 保持言行一致，说到做到</li>
            <li>• 开放透明的沟通，不隐瞒重要事情</li>
            <li>• 尊重承诺，重视对方的感受</li>
            <li>• 给予稳定的关注和回应</li>
          </ul>
        </div>

        <!-- 平衡独立与亲密 -->
        <div class="space-y-3">
          <h4 class="font-semibold flex items-center gap-2 text-blue-700">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            平衡独立与亲密
          </h4>
          <ul class="text-sm text-gray-600 space-y-2 ml-6">
            <li>• 保持个人成长，不失去自我</li>
            <li>• 尊重彼此的私人空间和时间</li>
            <li>• 建立健康的关系边界</li>
            <li>• 鼓励对方的个人发展</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- 推荐学习资源 -->
  <div class="card">
    <div class="p-6 border-b border-gray-200">
      <h3 class="text-xl font-bold flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
        推荐学习资源
      </h3>
    </div>
    <div class="p-6">
      <div class="grid md:grid-cols-3 gap-4">
        <!-- 推荐书籍 -->
        <div class="p-4 bg-gray-50 rounded-lg">
          <h4 class="font-semibold mb-2 text-sm">📚 推荐书籍</h4>
          <ul class="text-xs text-gray-600 space-y-1">
            <li>• 《依恋理论》- Bowlby</li>
            <li>• 《亲密关系》- Rowland Miller</li>
            <li>• 《爱的五种语言》- Gary Chapman</li>
          </ul>
        </div>

        <!-- 在线课程 -->
        <div class="p-4 bg-gray-50 rounded-lg">
          <h4 class="font-semibold mb-2 text-sm">🎓 在线课程</h4>
          <ul class="text-xs text-gray-600 space-y-1">
            <li>• 亲密关系心理学</li>
            <li>• 情绪管理与沟通技巧</li>
            <li>• 依恋类型与关系模式</li>
          </ul>
        </div>

        <!-- 专业支持 -->
        <div class="p-4 bg-gray-50 rounded-lg">
          <h4 class="font-semibold mb-2 text-sm">💬 专业支持</h4>
          <ul class="text-xs text-gray-600 space-y-1">
            <li>• 情感心理咨询</li>
            <li>• 伴侣关系治疗</li>
            <li>• 依恋修复工作坊</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthyRelationshipGuide'
}
</script>

